module.exports = __webpack_public_path__ + "img/logo.802a8d24.png";